import { render, staticRenderFns } from "./AuthButtonLogin.vue?vue&type=template&id=f5c08964&"
import script from "./AuthButtonLogin.vue?vue&type=script&lang=js&"
export * from "./AuthButtonLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports